import {tva} from "@gluestack-ui/nativewind-utils/tva";

export const badgeStyle = tva({
    base: "flex-row flex gap-1 w-fit max-w-full items-center rounded-xs data-[disabled=true]:opacity-50",
    variants: {
        action: {
            error: "",
            warning: "",
            success: "",
            info: "",
            default: ""
        },
        variant: {
            solid: "",
            subtle: "border border-solid",
            outline: "border border-solid"
        },
        size: {
            sm: "px-1 py-0.5",
            md: "px-2 py-1"
        }
    },
    compoundVariants: [
        {
            action: "info",
            variant: "solid",
            class: "bg-blue-600"
        },
        {
            action: "info",
            variant: "subtle",
            class: "border-blue-200 bg-blue-50"
        },
        {
            action: "info",
            variant: "outline",
            class: "border-blue-200"
        },
        {
            action: "success",
            variant: "solid",
            class: "bg-success-600"
        },
        {
            action: "success",
            variant: "subtle",
            class: "border-green-200 bg-success-50"
        },
        {
            action: "success",
            variant: "outline",
            class: "border-green-200"
        },
        {
            action: "warning",
            variant: "solid",
            class: "bg-amber-500"
        },
        {
            action: "warning",
            variant: "subtle",
            class: "border-amber-200 bg-amber-50"
        },
        {
            action: "warning",
            variant: "outline",
            class: "border-amber-200"
        },
        {
            action: "error",
            variant: "solid",
            class: "bg-error-600"
        },
        {
            action: "error",
            variant: "subtle",
            class: "border-danger-200 bg-error-50"
        },
        {
            action: "error",
            variant: "outline",
            class: "border-danger-200"
        },
        {
            action: "default",
            variant: "solid",
            class: "bg-blueGray-600"
        },
        {
            action: "default",
            variant: "subtle",
            class: "border-blueGray-200 bg-blueGray-50"
        },
        {
            action: "default",
            variant: "outline",
            class: "border-blueGray-200"
        }
    ]
});

export const badgeTextStyle = tva({
    base: "text-xs font-medium flex-shrink",

    parentVariants: {
        action: {
            error: "",
            warning: "",
            success: "",
            info: "",
            muted: ""
        },
        variant: {
            solid: "text-blueGray-50",
            subtle: "",
            outline: ""
        }
    },
    parentCompoundVariants: [
        {
            action: "info",
            variant: ["outline", "subtle"],
            class: "text-blue-600"
        },
        {
            action: "success",
            variant: ["outline", "subtle"],
            class: "text-success-600"
        },
        {
            action: "warning",
            variant: ["outline", "subtle"],
            class: "text-amber-500"
        },
        {
            action: "error",
            variant: ["outline", "subtle"],
            class: "text-error-600"
        },
        {
            action: "default",
            variant: ["outline", "subtle"],
            class: "text-blueGray-600"
        }
    ]
});

export const badgeIconStyle = tva({
    base: "w-3 h-3",
    parentVariants: {
        action: {
            error: "",
            warning: "",
            success: "",
            info: "",
            muted: ""
        },
        variant: {
            solid: "fill-blueGray-50",
            outline: "",
            subtle: ""
        }
    },
    parentCompoundVariants: [
        {
            action: "info",
            variant: ["outline", "subtle"],
            class: "fill-blue-600"
        },
        {
            action: "success",
            variant: ["outline", "subtle"],
            class: "fill-success-600"
        },
        {
            action: "warning",
            variant: ["outline", "subtle"],
            class: "fill-amber-500"
        },
        {
            action: "error",
            variant: ["outline", "subtle"],
            class: "fill-error-600"
        },
        {
            action: "default",
            variant: ["outline", "subtle"],
            class: "fill-blueGray-600"
        }
    ]
});
